import { OfferFragment } from '@occc/graphql';
import { ConfigurationFormNameAndDescriptionValues } from '../../../types';

export const getOfferNameAndDescriptionInitialValues = (
  offer?: OfferFragment,
): ConfigurationFormNameAndDescriptionValues => {
  if (!offer) {
    return { name: '', description: '' };
  }

  return {
    name: offer.name || '',
    description: offer.description || '',
  };
};
